var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DpContainer',{staticClass:"text-center py-3"},[_c('h1',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.$t('dp.error.title')))]),_c('p',{staticClass:"my-4"},[_vm._v(" "+_vm._s(_vm.$t('dp.error.body'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }